import React, { Fragment, useEffect, useState } from "react";
import { NONCE } from "@data/GlobalData.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import {
  CFW_CURRENT_URL,
  CFW_HYDRATION_COMPLETE,
  CFW_LOAD_MENU,
  CFW_UPDATE_DEFAULT_DATA,
} from "@genericComponents/CFW.js";
import { GetConfig } from "@genericComponents/SFW.js";
import {
  GetState,
  initDefaultData,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
import { OnlyAlphaNumeric } from "@genericComponents/Common.js";
import { Folders, GetFile } from "@genericComponents/FileFW.js";
import { GetDataWorker } from "@genericComponents/SSRFW.js";
import { UploadFile } from "@asyncImports/UploadFile.js";
const AddScriptsWithCallBack =
  await import("@asyncImports/AddScriptsWithCallBack.js").then(
    (mod) => mod.AddScriptsWithCallBack,
  );

const isDeepEqual = await import("@asyncImports/isDeepEqual.js").then(
  (mod) => mod.isDeepEqual,
);
const CommonDebouncer = await import("@asyncImports/CommonDebouncer.js").then(
  (mod) => mod.CommonDebouncer,
);
const actionName = "InitializeScripts";
const executeUpdate = async (defaultData, fileName) => {
  const newDefaultdata = Object.fromEntries(initDefaultData);
  if (!isDeepEqual(defaultData, newDefaultdata)) {
    const fileContent = btoa(
      JSON.stringify({ ...defaultData, ...newDefaultdata }),
    );
    UploadFile(fileContent, Folders.DefaultInitData, fileName);
    initDefaultData.clear();
    RemoveState(CFW_UPDATE_DEFAULT_DATA);
  }
};
const UpdateDefaultData = () => {
  const updateDefaultData = useGenericStore(CFW_UPDATE_DEFAULT_DATA);
  const [curentUrlJson, setCurentUrlJson] = useState(null);
  const defaultData = initDefaultData;
  const fileName = [
    OnlyAlphaNumeric(GetState(CFW_CURRENT_URL), true),
    "json",
  ].join(".");
  const executeUpdateEvent = () => {
    executeUpdate(curentUrlJson, fileName);
  };
  useEffect(() => {
    if (defaultData.size) {
      if (!curentUrlJson) {
        GetDataWorker(
          GetFile(Folders.DefaultInitData, fileName, null, true),
          null,
          null,
        )
          .then((results) => {
            setCurentUrlJson(results ?? {});
          })
          .catch((ex) => {
            console.log("error", ex.message);
            setCurentUrlJson({});
          });
      } else {
        CommonDebouncer(CFW_UPDATE_DEFAULT_DATA, executeUpdateEvent, 1000);
      }
    }
  }, [updateDefaultData, curentUrlJson]);
  return <Fragment />;
};
const AddScripts = () => {
  window.fbAsyncInit = () => {
    window.FB.init({
      appId: GetConfig("FacebookAppId"),
      cookie: true,
      xfbml: true,
      version: "v20.0",
    });
    window.FB.AppEvents.logPageView();
  };
  ((d, s, id) => {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id) || !fjs) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.setAttribute("nonce", NONCE);
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
};
export const InitializeScripts = ({ isMobile }) => {
  const hydrationComplete = useGenericStore(CFW_HYDRATION_COMPLETE, false);
  useEffect(() => {
    if (hydrationComplete || !isMobile) {
      import("@css/lazyStyles.css");
      SetState(CFW_LOAD_MENU, true);
      if (!isMobile) {
        AddScripts();
      } else {
        CommonDebouncer(actionName, AddScripts, 2000);
      }
    }
    AddScriptsWithCallBack(
      "https://www.googletagmanager.com/gtag/js?id=G-W771Q9TVB5",
      "google-analytics",
      {
        async: "",
        nonce: NONCE,
      },
      () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-W771Q9TVB5");
      },
    );
  }, [hydrationComplete, isMobile]);
  return hydrationComplete ? <UpdateDefaultData /> : <Fragment />;
};
